import { Vue, Component } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import * as user from "@/store/modules/user/types";

@Component
export default class UserMixin extends Vue {
  @State(user.name) userState!: user.UserState;

  @Getter("UserName", { namespace: user.name }) UserName!: string;

  public get User(): user.User {
    return this.userState.user;
  }

  protected isDisabled(subAuthName = "is_edit") {
    // 現在のユーザー権限情報とルーティング情報に設定されている権限情報を比較して権限がないかを判定

    // ルーティング情報に設定されている権限情報
    const routeAuth = this.$router.currentRoute.meta?.authName as string;
    if (!routeAuth) {
      // 設定されていない場合は無効化する
      return true;
    }

    // ログインユーザーの権限情報
    const userAuth = this.User.admin_auth;

    // adminFunctionに設定されているpathがルーティング情報のauthNameと一致しない場合はNG
    const filteredUserAuthFunctions = userAuth.admin_auth_functions.filter(
      (data) => {
        return data.function.path == routeAuth;
      }
    );

    // pathがルーティング情報のauthNameと一致しない場合はNG
    if (filteredUserAuthFunctions.length == 0) {
      return true;
    }

    // pathは存在しているが、編集権限が設定されていない場合はNG
    if (!filteredUserAuthFunctions[0].editing_auths[0].allowed) {
      return true;
    }

    // 編集権限は設定されているが、サブ権限がない場合はNG
    if (
      !filteredUserAuthFunctions[0].editing_auths.filter((data) => {
        return data.key == subAuthName && data.allowed;
      }).length
    ) {
      return true;
    }

    return false;
  }
}
